import { Box, ButtonBase, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

const DropButton = ({ text, options, onClick, onOptionClicked, stroked, buttonOptions }) => {
  const [opened, setOpened] = useState(false);

  const OptionComponent = buttonOptions ? ButtonBase : Box;

  return (
    <>
      <Box style={{ width: "100%" }}>
        <ButtonBase
          style={{
            width: "100%",
            height: "50px",
            background: stroked ? "rgba(0,0,0,0)" : "linear-gradient(225deg, #FF9700, #FF6401)",
            borderRadius: "10px",
            justifyContent: "space-between",
            padding: "10px 20px",
            zIndex: 1,
            border: stroked ? "2px solid #FF6401" : "none",
          }}
          onClick={() => {
            setOpened(!opened);
          }}
        >
          <Typography
            style={{
              fontWeight: "500",
              fontSize: "18px",
              color: stroked ? "#FF9700" : "white",
              textAlign: "left",
            }}
          >
            {text}
          </Typography>
          {opened ? (
            <ArrowDropUpIcon
              style={{
                color: stroked ? "#FF9700" : "white",
              }}
            />
          ) : (
            <ArrowDropDownIcon
              style={{
                color: stroked ? "#FF9700" : "white",
              }}
            />
          )}
        </ButtonBase>
        {opened && options && options.length > 0 && (
          <Box
            style={{
              border: "2px solid #FF6401",
              borderRadius: "10px",
              position: "relative",
              marginTop: "-50px",
              paddingTop: "50px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {options.map((option, index) => (
              <OptionComponent
                key={index}
                style={{
                  width: "100%",
                  height: "40px",
                  background: "rgba(0,0,0,0)",
                  justifyContent: "center",
                  zIndex: 1,
                  border: "none",
                }}
                onClick={buttonOptions ? () => (onOptionClicked ? onOptionClicked(option) : undefined) : undefined}
              >
                <Typography
                  style={{
                    fontWeight: "500",
                    fontSize: "18px",
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  {option.text}
                </Typography>
              </OptionComponent>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};

export default DropButton;
